export default "__VITE_ASSET__j17QEaay__"